import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Clock, TrendingUp } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { Badge } from '../components/ui/badge';
import { newsAPI } from '../services/api';
import SEO from '../components/seo/SEO';

const categoryLabels = {
  'ekonomi': 'Ekonomi',
  'politika': 'Politika',
  'vizyon-sektor': 'Vizyon Sektör',
  'dunya': 'Dünya',
  'teknoloji': 'Teknoloji',
  'finans': 'Finans',
};

const categoryColors = {
  'ekonomi': 'from-blue-600 to-blue-800',
  'politika': 'from-purple-600 to-purple-800',
  'vizyon-sektor': 'from-red-600 to-red-800',
  'dunya': 'from-green-600 to-green-800',
  'teknoloji': 'from-indigo-600 to-indigo-800',
  'finans': 'from-emerald-600 to-emerald-800',
};

// Mock data for categories
const MOCK_NEWS_BY_CATEGORY = {
  'ekonomi': [
    { id: 'e1', title: 'Merkez Bankası Faiz Kararı: Piyasalar Beklentide', body: 'TCMB Para Politikası Kurulu toplantısı öncesinde piyasalarda temkinli bekleyiş hakim.', image_url: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop', created_at: new Date().toISOString() },
    { id: 'e2', title: 'Enflasyon Rakamları Açıklandı', body: 'TÜİK verilerine göre yıllık enflasyon beklentilerin üzerinde gerçekleşti.', image_url: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 3600000).toISOString() },
    { id: 'e3', title: 'İhracat Rekoru Kırıldı', body: 'Türkiye ihracatı tarihi zirveye ulaştı. İhracatçılar birlikler hedeflerin üzerine çıkıldığını açıkladı.', image_url: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 7200000).toISOString() },
    { id: 'e4', title: 'Sanayi Üretimi Artışa Geçti', body: 'Sanayi üretim endeksi aylık bazda yüzde 2.3 artış kaydetti.', image_url: 'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 14400000).toISOString() },
    { id: 'e5', title: 'Cari Denge Verileri Yayınlandı', body: 'Cari işlemler dengesi beklentilerin altında açık verdi.', image_url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 21600000).toISOString() },
    { id: 'e6', title: 'Büyüme Rakamları Açıklandı', body: 'GSYİH verileri ekonomideki toparlanma sinyallerini güçlendirdi.', image_url: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 28800000).toISOString() },
  ],
  'finans': [
    { id: 'f1', title: 'BIST 100 Rekor Seviyede', body: 'Borsa İstanbul endeksi yabancı yatırımcı girişiyle tarihi zirvesini test ediyor.', image_url: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=800&h=450&fit=crop', created_at: new Date().toISOString() },
    { id: 'f2', title: 'Altın Fiyatları Yükseliyor', body: 'Ons altın küresel belirsizliklerle birlikte değer kazanmaya devam ediyor.', image_url: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 3600000).toISOString() },
    { id: 'f3', title: 'Dolar/TL Son Durum', body: 'Döviz piyasalarında dalgalanma sürüyor. Analistler değerlendirmelerini paylaştı.', image_url: 'https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 7200000).toISOString() },
    { id: 'f4', title: 'Bankacılık Sektöründe Yeni Düzenlemeler', body: 'BDDK yeni düzenlemeleri açıkladı, sektör temsilcileri değerlendirdi.', image_url: 'https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 14400000).toISOString() },
    { id: 'f5', title: 'Kripto Para Piyasalarında Hareketlilik', body: 'Bitcoin ve Ethereum değer kazanırken, altcoinlerde dalgalanma sürüyor.', image_url: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 21600000).toISOString() },
  ],
  'politika': [
    { id: 'p1', title: 'Türkiye-AB İlişkilerinde Yeni Dönem', body: 'AB ile üst düzey görüşmeler başladı, vize serbestisi gündemde.', image_url: 'https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800&h=450&fit=crop', created_at: new Date().toISOString() },
    { id: 'p2', title: 'Meclis\'te Önemli Oylamalar', body: 'TBMM genel kurulunda kritik yasa tasarıları görüşülüyor.', image_url: 'https://images.unsplash.com/photo-1575320181282-9afab399332c?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 3600000).toISOString() },
    { id: 'p3', title: 'Dış Politika Gelişmeleri', body: 'Bölgesel konularda üst düzey diplomatik temaslar sürüyor.', image_url: 'https://images.unsplash.com/photo-1541872705-1f73c6400ec9?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 7200000).toISOString() },
    { id: 'p4', title: 'Yerel Seçim Hazırlıkları', body: 'Partiler yerel seçimlere yönelik stratejilerini belirlemeye başladı.', image_url: 'https://images.unsplash.com/photo-1494172892981-ce47ca3f2227?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 14400000).toISOString() },
  ],
  'teknoloji': [
    { id: 't1', title: 'Yapay Zeka Yatırımları Artıyor', body: 'Türk teknoloji şirketleri yapay zeka alanında büyük yatırımlar yapıyor.', image_url: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=450&fit=crop', created_at: new Date().toISOString() },
    { id: 't2', title: 'Yerli Yazılım Başarısı', body: 'Türk yazılım şirketleri uluslararası arenada başarılarını artırıyor.', image_url: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 3600000).toISOString() },
    { id: 't3', title: 'Startup Ekosistemi Büyüyor', body: 'Türkiye startup ekosisteminde yeni unicorn adayları ortaya çıkıyor.', image_url: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 7200000).toISOString() },
    { id: 't4', title: 'Siber Güvenlik Önlemleri', body: 'Şirketler siber güvenlik yatırımlarını artırıyor.', image_url: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 14400000).toISOString() },
    { id: 't5', title: '5G Altyapı Yatırımları', body: '5G altyapısı için yapılan yatırımlar hız kazandı.', image_url: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 21600000).toISOString() },
  ],
  'dunya': [
    { id: 'd1', title: 'Küresel Ekonomi Görünümü', body: 'IMF küresel ekonomik büyüme tahminlerini güncelledi.', image_url: 'https://images.unsplash.com/photo-1526470608268-f674ce90ebd4?w=800&h=450&fit=crop', created_at: new Date().toISOString() },
    { id: 'd2', title: 'ABD Merkez Bankası Kararı', body: 'Fed faiz kararını açıkladı, piyasalar tepki verdi.', image_url: 'https://images.unsplash.com/photo-1569025743873-ea3a9ber38d4?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 3600000).toISOString() },
    { id: 'd3', title: 'Avrupa Birliği Zirvesi', body: 'AB liderleri kritik konuları görüşmek üzere bir araya geldi.', image_url: 'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 7200000).toISOString() },
    { id: 'd4', title: 'Asya Piyasaları Değerlendirmesi', body: 'Asya borsalarında yeni hafta hareketli başladı.', image_url: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=800&h=450&fit=crop', created_at: new Date(Date.now() - 14400000).toISOString() },
  ],
};

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);

  if (diffMins < 60) return `${diffMins} dakika önce`;
  if (diffHours < 24) return `${diffHours} saat önce`;
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
};

const CategoryPage = () => {
  const { slug } = useParams();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategoryNews();
  }, [slug]);

  const fetchCategoryNews = async () => {
    setLoading(true);
    try {
      const response = await newsAPI.getAll({ category: slug, limit: 20 });
      if (response.data && response.data.length > 0) {
        setNews(response.data);
      } else {
        // Use mock data as fallback
        setNews(MOCK_NEWS_BY_CATEGORY[slug] || []);
      }
    } catch (error) {
      console.error('Error fetching category news:', error);
      // Use mock data as fallback
      setNews(MOCK_NEWS_BY_CATEGORY[slug] || []);
    } finally {
      setLoading(false);
    }
  };

  const categoryName = categoryLabels[slug] || slug;
  const categoryColor = categoryColors[slug] || 'from-gray-600 to-gray-800';

  return (
    <Layout>
      <SEO
        title={`${categoryName} Haberleri`}
        description={`${categoryName} kategorisindeki en güncel haberler, analizler ve özel içerikler — Haber Türkiye'den.`}
        keywords={`${categoryName.toLowerCase()}, ${slug}, haber, türkiye`}
        image={news[0]?.image_url}
      />
      <div data-testid="category-page">
        {/* Category Hero */}
        <div className={`bg-gradient-to-r ${categoryColor} py-12`}>
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex items-center gap-3 mb-2">
              <TrendingUp className="w-6 h-6 text-white/70" />
              <span className="text-white/70 text-sm uppercase tracking-wider">Kategori</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white tracking-tight">
              {categoryName}
            </h1>
            <p className="text-white/70 mt-2">
              {categoryName} kategorisindeki tüm haberler
            </p>
          </div>
        </div>

        {/* News Content */}
        <div className="max-w-7xl mx-auto px-4 py-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="bg-white rounded-lg overflow-hidden shadow-sm animate-pulse">
                  <div className="aspect-[16/9] bg-gray-200" />
                  <div className="p-4 space-y-3">
                    <div className="h-4 bg-gray-200 rounded w-3/4" />
                    <div className="h-4 bg-gray-200 rounded w-1/2" />
                    <div className="h-3 bg-gray-200 rounded w-1/4" />
                  </div>
                </div>
              ))}
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-16 bg-gray-50 rounded-lg">
              <p className="text-gray-500 text-lg">Bu kategoride henüz haber bulunmuyor.</p>
            </div>
          ) : (
            <>
              {/* Featured Article */}
              {news[0] && (
                <div className="mb-8">
                  <Link to={`/haber/${news[0].id}`} className="group block">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                      <div className="aspect-[16/10] lg:aspect-auto overflow-hidden">
                        <img
                          src={news[0].image_url}
                          alt={news[0].title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6 flex flex-col justify-center">
                        <Badge className={`w-fit mb-3 bg-gradient-to-r ${categoryColor} text-white`}>
                          {categoryName}
                        </Badge>
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight group-hover:text-red-600 transition-colors">
                          {news[0].title}
                        </h2>
                        <p className="text-gray-600 mt-3 line-clamp-3">{news[0].body}</p>
                        <span className="text-gray-400 text-sm mt-4 flex items-center gap-1">
                          <Clock className="w-4 h-4" />
                          {formatDate(news[0].created_at)}
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              )}

              {/* News Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {news.slice(1).map((item) => (
                  <Link key={item.id} to={`/haber/${item.id}`} className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={item.image_url}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-bold text-gray-900 leading-tight group-hover:text-red-600 transition-colors line-clamp-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-500 text-sm mt-2 line-clamp-2">{item.body}</p>
                      <span className="text-gray-400 text-xs mt-3 flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {formatDate(item.created_at)}
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CategoryPage;
